import { types } from 'mobx-state-tree';
import _ from 'lodash';
var QuerySorting = types.model({
    orderBy: types.optional(types.string, 'updatedAt'),
    sortOrder: types.optional(types.number, 0),
    searchAfter: types.maybe(types.string)
})
    .named('QuerySorting')
    .views(function (self) { return ({
    get isAscending() {
        return self.sortOrder === 0;
    },
    get isDescending() {
        return self.sortOrder === 1;
    }
}); })
    .actions(function (self) { return ({
    setOrderBy: function (orderBy) {
        self.orderBy = orderBy;
    },
    setSortOrder: function (sortOrder) {
        self.sortOrder = sortOrder === 'ascending' ? 0 : 1;
    },
    setSearchAfter: function (searchAfter) {
        if (_.isDate(searchAfter)) {
            self.searchAfter = JSON.stringify(searchAfter.getTime());
        }
        else {
            self.searchAfter = JSON.stringify(searchAfter);
        }
    },
    removeSearchAfter: function () {
        self.searchAfter = undefined;
    }
}); });
export default QuerySorting;
//# sourceMappingURL=QuerySorting.js.map